<template>
<div>
    <banner></banner>
    <div class="container">
        <div class="todaynew">
            <div class="todayname">近期上新</div>
            <div v-for="(item,index) in moduleFirst" :key="index">
                <div class="todaybook" v-if="index == 0">
                    <today-book v-bind:books="item"></today-book>
                </div>
                <div v-else>
                    <book-item v-bind:books="item"></book-item>
                </div>
            </div>
        </div>

    </div>
	
	<div class="container">
		<div class="typename">路读FM <span @click="getMore(0,43)" class="more">查看更多</span></div>
		<div v-for="(item,index) in moduleFM" :key="index">
			<fm-item v-bind:books="item"></fm-item>
		</div>
	</div>
	
    <div class="container">
        <div class="typename">精选书单 <span @click="getMore(2,-2)" class="more">查看更多</span></div>
        <div class="scrollx">
            <div v-for="(item,index) in featuredBook" :key="index">
                <featured-book v-bind:books="item"></featured-book>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="typename">名师讲堂 <span @click="getMore(3,-2)" class="more">查看更多</span></div>
        <div class="scrollx">
            <div v-for="(item,index) in teacherLectureBook" :key="index">
                <ming-shi v-bind:books="item"></ming-shi>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="typename">系列连载 <span @click="getMore(4,-2)" class="more">查看更多</span></div>
        <div class="scrollx">
            <div v-for="(item,index) in serialsBook" :key="index">
                <lian-zai v-bind:books="item"></lian-zai>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="typename">近期热点</div>
        <div class="hotarea">
            <ul>
                <div v-for="(item,index) in focusBook" :key="index">
                    <router-link :to="{path:'/bookdetail',query:{bookId:item.bookId}}">
                        <li>
                            <div class="dot"></div> {{item.hotSpotName}} <span>{{item.author}}</span>
                        </li>
                    </router-link>
                </div>
            </ul>
        </div>
    </div>
    <div class="container">
        <div v-for="(item,index) in moduleThird" :key="index">
            <div class="typename">{{item.typeName}} <span @click="getMore(0,item.typeId)" class="more">查看更多</span></div>
            <div class="bookscontent">
                <div v-for="(items,i) in item.bookSearchList" :key="i">
                    <book-item v-bind:books="items" v-if="i<9"></book-item>
                </div>
            </div>
        </div>
    </div>
    <div class="height30"></div>
</div>
</template>

<style scoped>
.todaynew {
    width: 100%;
    margin-top: 20px;
    background: linear-gradient(180deg, #F6F9F9 0%, rgba(245, 246, 246, 0) 70%);
}

.todayname {
    padding: 30px 0 0px 20px;
    font-size: 28px;
    font-family: Source Han Serif CN;
    font-weight: bold;
    color: #242A27;

}

.todaybook {
    padding-bottom: 30px;
}

.typename {
    margin: 50px 0 0px 0;
    font-size: 28px;
    font-family: Source Han Serif CN;
    font-weight: bold;
    color: #242A27;

}

.bookscontent {
    overflow: hidden;
}

.more {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #4CCCAA;
    float: right;
    cursor: pointer;
}

.more:hover {
    color: #242A27;
}

.scrollx {
    display: -webkit-box;
    display: box;
    display: -moz-box;
    overflow-x: scroll;
    padding-top: 20px;
}

.hotarea {
    background-color: #282c2a;
    overflow: hidden;
    padding: 30px 40px 30px 0px;
    margin: 30px 0;
}

.hotarea a {
    text-decoration: none;
    color: #EAF1F1;
}

.hotarea a:hover {
    color: #bebebe;
}

.hotarea ul {
    list-style: none;
    margin: 0;
}

.hotarea ul li {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 450;
    padding: 20px;
}

.dot {
    width: 4px;
    height: 18px;
    background: linear-gradient(0deg, #E8CE4D, #282c2a);
    float: left;
    margin-right: 10px;
    margin-top: 2px;
}

.hotarea ul li span {
    float: right;
    font-size: 16px;
}
</style>

<script>
// @ is an alias to /src  
import Banner from '@/components/Banner'
import BookItem from '@/components/BookItem'
import FmItem from '@/components/FmItem.vue'
import TodayBook from '@/components/TodayBook'
import FeaturedBook from '@/components/FeaturedBook'
import MingShi from '@/components/MingShi'
import LianZai from '@/components/LianZai'
import {getCookie} from '@/network/cookie.js'
export default {
    metaInfo() {
        return{
        title: '路上畅听官方网站首页' + this.$store.state.title,
        meta: [
          { vmid: 'keywords', name: 'keywords', content: this.$store.state.keywords },
          { vmid: 'description', name: 'description', content: this.$store.state.description }
        ] 
        }
    },
    name: 'Home',
    components: {
        Banner,
        BookItem,
		FmItem,
        TodayBook,
        FeaturedBook,
        MingShi,
        LianZai,
    },
    data() {
        return {
            moduleFirst: {},
			moduleFM:{},
            //moduleSecond: {},
            teacherLectureBook: {},
            serialsBook: {},
            focusBook: {},
            featuredBook: {},
            moduleThird: {},
            sessionId:getCookie('sessionId')
        }
    },
    methods: {
        getModuleFirst: function () { 
            this.$http.get({
                url: '/xcx/index/book-list-module-first?sessionId='+this.sessionId
            }).then(res => {
                this.moduleFirst = res.data.data.newBook.list;
				this.moduleFM = res.data.data.LuDuFM.list;
            })
        },
        getModuleSecond: function () {
            this.$http.get({
                url: '/xcx/index/book-list-module-second?sessionId='+this.sessionId
            }).then(res => {
                //this.moduleSecond = res.data.data;
                this.teacherLectureBook = res.data.data.teacherLectureBook.list;
                this.serialsBook = res.data.data.serialsBook.list;
                this.featuredBook = res.data.data.featuredBook.list;
                this.focusBook = res.data.data.focusBook.list;
            })
        },
        getModuleThird: function () {
            this.$http.get({
                url: '/xcx/index/book-list-module-third?sessionId='+this.sessionId
            }).then(res => {
                this.moduleThird = res.data.data.selectionBook.list;
            })
        },
        getMore: function (listType, typeId) {
            this.$router.push({
                path: '/library?listType=' + listType + '&id=' + typeId
            })
        }
    },
    mounted() {
        this.getModuleFirst();
        this.getModuleSecond();
        this.getModuleThird();
    },
}
</script>
